var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`bottom-margin-${_vm.bottomMargin}`},[_c('div',{class:['field', `label-${_vm.labelPosition}`, _vm.variant]},[_c(_vm.is,{tag:"component",class:['field-label', `label-${_vm.labelPosition}`],attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{class:[
        'field-input',
        `label-${_vm.labelPosition}`,
        _vm.id ? 'fixed' : 'free'
      ]},[_vm._t("default")],2)],1),(_vm.error)?_c('span',{staticClass:"error-text"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }